import React from "react";
import icon404 from "./assets/icon404.png";

function Page404() {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="flex flex-col sm:flex-row items-center gap-8 max-w-lg">
        <img src={icon404} alt="Page Not Found" className="w-32 sm:w-40" />
        <div className="text-center sm:text-left">
          <h1 className="text-6xl font-bold text-brand-300">404</h1>
          <p className="mt-2 text-gray-500">
            The page you are looking for does not exist or has been moved.
          </p>
          <a
            href="/"
            className="mt-4 inline-block rounded-lg bg-brand-300 px-5 py-2 text-sm font-semibold text-white uppercase hover:bg-brand-400 transition"
          >
            Go to Home
          </a>
        </div>
      </div>
    </div>
  );
}

export default Page404;
